import React from 'react';
import './content-views.scss'
import EyeIcon from '/react4xp/mixins/ui/icons/eye-icon.svg';
import {localize} from "/react4xp/mixins/helpers";

export default (props: any) => {
    return (
        <div className="d-flex align-items-center gap-2 my-3" title={localize('views-counter', props.translations)}>
            <EyeIcon />
            {props.views}
        </div>
    );
};
